module.exports = __webpack_public_path__ + "static/img/carousel_4_ur2nwj_ar_16_9_w_1742.e3670b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_4_ur2nwj_ar_16_9_w_1742.jpg
// module id = snYz
// module chunks = 0